import moment from 'moment';
import React from 'react';

function SchoolLeavingCertificate(props) {
    return (
        <>
            <div style={{ width: '624px', fontSize: '14px', height: 'auto', margin: '336px auto 0 auto', lineHeight: '25px' }} align="left">
                <div align="center">
                    <h3 className="style1" style={{ marginBottom: '20px', textDecoration: "underline" }}>
                        SCHOOL LEAVING CERTIFICATE</h3>
                </div>
                <div align="right">
                    Student Code: {props.code}
                </div>
                <br />
                <br />
                <div>
                    This is certified that <strong>{props.name}</strong> S/O <strong>{props.fathername}</strong> was admitted in this school on {moment(props.doj).format("MMM DD, YYYY")} and left on {moment(props.leftdate).format("MMM DD, YYYY")}. He was studying in the 
                    &nbsp;<span>{props.class}</span>. 
                    <br />
                    <br />
                    <div>
                       He has paid fee upto {props.paymentdate}.</div><br />
                    <div>
                        His date of birth according to the admission
                        and withdrawal register is <strong>{moment(props.dob).format("MMM DD, YYYY")}</strong>.</div>
                    <span>{props.extraline}</span>
                    <br />
                    <br />
                </div>
                We wish his best of luck and success.
                <br />
                <br />
                <div align="left">
                    Dated: {moment().format("MMM DD, YYYY")}
                </div>
                <br />
                <div style={{ marginLeft: '400px', lineHeight: '18px' }}>
                    <b>Principal</b><br />
                    District Jinnah Public School <br />
                    &amp; College, M.B.Din.
                </div>
            </div>
        </>
    );
}

export default SchoolLeavingCertificate;